import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, TrustStrip, SectionHeading } from "@/components/site/shared";
import { QuoteForm } from "@/components/site/QuoteForm";
import { useContent } from "@/lib/ContentContext";

const FOCUS = ["Commercial soft washing", "Building exterior cleaning", "Concrete cleaning", "Walkway & entrance cleaning", "Recurring cleaning inquiries", "Property-specific quote requests"];
const TYPES = ["Businesses", "Retail properties", "Offices", "Property managers", "Associations", "Commercial facilities"];

export default function Commercial() {
  const { content } = useContent();
  return (
    <div>
      <PageHeader overline="For Businesses" title="Commercial Exterior Cleaning" subtitle={content.commercial_intro} />
      <section className="py-8 bg-[var(--bg-light)]"><div className="max-w-7xl mx-auto px-4"><TrustStrip /></div></section>

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-[1fr_460px] gap-12">
          <div>
            <SectionHeading overline="What We Handle" title="Commercial Cleaning Services" />
            <div className="grid sm:grid-cols-2 gap-3">
              {FOCUS.map((n) => <div key={n} className="flex items-center gap-2 bg-white border border-gray-100 rounded-xl px-4 py-3 card-shadow"><Check className="w-5 h-5 text-[var(--aqua)]" /> {n}</div>)}
            </div>
            <div className="mt-10">
              <h3 className="font-head font-bold text-2xl text-[var(--navy)] uppercase mb-4">Who We Serve</h3>
              <div className="flex flex-wrap gap-2">
                {TYPES.map((t) => <span key={t} className="bg-[var(--navy)] text-white px-4 py-2 rounded-full text-sm">{t}</span>)}
              </div>
            </div>
            <p className="text-sm text-[var(--text-muted)] mt-8">{content.service_area_note}</p>
          </div>
          <div className="lg:sticky lg:top-24 h-fit bg-white border border-gray-100 rounded-2xl card-shadow p-6">
            <h3 className="font-head font-bold text-xl text-[var(--navy)] uppercase mb-4">Request Commercial Service</h3>
            <QuoteForm variant="commercial" source="commercial_page" />
          </div>
        </div>
      </section>
    </div>
  );
}
